<template>
  <div>
    <transferenceManagebar />
    <v-container fluid>
      <base-material-card
        icon="mdi-clipboard-text"
        title="รายละเอียดการยื่นย้าย (ประมวลผลแบบที่ 2)"
      >
        <v-row dense class="align-center">
          <v-col cols="12" md="4">
            <v-select
              v-model="selectedHeaders"
              :items="headers"
              label="เลือกคอลัมน์ที่ต้องการแสดง"
              multiple
              outlined
              dense
              return-object
              hide-details
            >
              <template v-slot:selection="{ item, index }">
                <v-chip v-if="index < 3" small>
                  <span>{{ item.text }}</span>
                </v-chip>
                <span v-if="index === 3" class="grey--text caption"
                  >(+{{ selectedHeaders.length - 3 }} คอลัมน์)</span
                >
              </template>
            </v-select>
          </v-col>
          <v-col cols="12" md="4">
            <v-radio-group
              v-model="position"
              @change="positionSearch()"
              row
              hide-details
              class="mt-0"
            >
              <v-radio
                label="ผู้อำนวยการวิทยาลัย"
                value="ผู้อำนวยการวิทยาลัย"
              ></v-radio>
              <v-radio
                label="รองผู้อำนวยการวิทยาลัย"
                value="รองผู้อำนวยการวิทยาลัย"
              ></v-radio>
            </v-radio-group>
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="ค้นหา ระบุคำ หรือ ส่วนข้อความเกี่ยวข้อง"
              single-line
              hide-details
              dense
              filled
            />
          </v-col>
          <v-col cols="12" md="1" class="text-md-right">
            <v-btn small rounded color="success" dark @click="exportToExcel">
              <v-icon left small>mdi-file-excel</v-icon>Excel
            </v-btn>
          </v-col>
        </v-row>

        <!-- ══════════════════════════════════════════════════════════════
             Dashboard สถิติ — คำนวณจาก transference_manage_locations ที่โหลดมาแล้ว
             ไม่ต้องเรียก API เพิ่ม
             ══════════════════════════════════════════════════════════════ -->
        <v-row dense class="mt-3">
          <v-col cols="12" sm="4">
            <v-card outlined class="pa-3 text-center">
              <div class="text-h4 font-weight-bold primary--text">{{ statTotalApplicants }}</div>
              <div class="caption grey--text">ผู้ยื่นย้ายทั้งหมด (รายการ)</div>
            </v-card>
          </v-col>
          <v-col cols="12" sm="4">
            <v-card outlined class="pa-3 text-center">
              <div class="text-h4 font-weight-bold info--text">{{ statTotalColleges }}</div>
              <div class="caption grey--text">วิทยาลัยปลายทางที่ถูกเลือก</div>
            </v-card>
          </v-col>
          <v-col cols="12" sm="4">
            <v-card outlined class="pa-3 text-center">
              <div class="text-h4 font-weight-bold success--text">{{ statTotalAssigned }}</div>
              <div class="caption grey--text">มอบหมายตำแหน่งแล้ว</div>
            </v-card>
          </v-col>
        </v-row>

        <v-row dense class="mb-2">
          <v-col cols="12" md="6">
            <v-card outlined class="pa-3">
              <div class="subtitle-1 font-weight-medium mb-2">
                10 อันดับวิทยาลัยปลายทางที่มีผู้ยื่นย้ายเลือกมากที่สุด
              </div>
              <apexchart
                type="bar"
                height="300"
                :options="topCollegesChartOptions"
                :series="topCollegesChartSeries"
              ></apexchart>
            </v-card>
          </v-col>
          <v-col cols="12" md="3">
            <v-card outlined class="pa-3">
              <div class="subtitle-1 font-weight-medium mb-2">สัดส่วนกรณีการย้าย</div>
              <apexchart
                type="donut"
                height="300"
                :options="caseMoveChartOptions"
                :series="caseMoveChartSeries"
              ></apexchart>
            </v-card>
          </v-col>
          <v-col cols="12" md="3">
            <v-card outlined class="pa-3">
              <div class="subtitle-1 font-weight-medium mb-2">
                สัดส่วนความเห็นสถานศึกษาปลายทาง
              </div>
              <apexchart
                type="donut"
                height="300"
                :options="opinionChartOptions"
                :series="opinionChartSeries"
              ></apexchart>
            </v-card>
          </v-col>
        </v-row>

        <v-data-table
          :headers="showHeaders"
          :items="transference_manage_locations"
          :search="search"
          :loading="loading"
          group-by="manage_location_college_code"
          item-key="manage_location_id_tfl"
          disable-pagination
          hide-default-footer
          class="mt-2"
        >
          <template v-slot:group.header="{ items, isOpen, toggle }">
            <td :colspan="showHeaders.length" @click="toggle" style="cursor:pointer;">
              <v-icon>{{ isOpen ? "mdi-chevron-up" : "mdi-chevron-down" }}</v-icon>
              <strong class="ml-1">{{ items[0].college_name }}</strong>
              <span class="grey--text ml-2">รหัสวิทยาลัย: {{ items[0].manage_location_college_code }}</span>
              <v-chip small color="primary" dark class="ml-2">
                {{ items.length }} คน ยื่นย้ายเข้า
              </v-chip>
              <v-chip
                v-for="v in groupVacancySummary(items)"
                :key="v.position_name"
                small
                :color="v.count > 0 ? 'success' : 'grey'"
                dark
                class="ml-1"
              >
                {{ v.position_name }}: ว่าง {{ v.count }} ตำแหน่ง
              </v-chip>
            </td>
          </template>

          <template v-slot:item.manage_case_move="{ item }">
            <v-chip v-if="item.manage_case_move === 'normal'" color="primary" small
              >ปกติ</v-chip
            >
            <v-chip v-if="item.manage_case_move === 'quality'" color="info" small
              >คุณภาพ</v-chip
            >
            <v-chip v-if="item.manage_case_move === 'special'" color="warning" small
              >กรณีพิเศษ</v-chip
            >
          </template>

          <!-- ความเห็นสถานศึกษาปลายทาง: คลิก chip เปิด PDF Dialog (read-only) -->
          <template v-slot:item.Mcommittee="{ item }">
            <v-chip
              v-if="item.Mcommittee === 'approp'"
              color="success"
              dark
              small
              style="cursor:pointer;"
              @click.stop="openPdfDialog(item)"
            >
              <v-icon left small>mdi-file-pdf-box</v-icon>เห็นควรให้รับย้าย
            </v-chip>
            <v-chip
              v-else-if="item.Mcommittee === 'inapprop'"
              color="warning"
              dark
              small
              style="cursor:pointer;"
              @click.stop="openPdfDialog(item)"
            >
              <v-icon left small>mdi-file-pdf-box</v-icon>ไม่เห็นควรให้รับย้าย
            </v-chip>
            <span v-else class="grey--text caption">ยังไม่ให้ความเห็น</span>
          </template>

          <template v-slot:item.college_name_suss="{ item }">
            <v-chip v-if="item.college_name_suss" color="success" dark small>
              {{ item.college_name_suss }}
            </v-chip>
            <span v-else class="grey--text caption">ยังไม่มอบหมาย</span>
          </template>

          <v-alert slot="no-results" :value="true" color="error" icon="mdi-alert">
            ไม่พบผลลัพธ์ "{{ search }}" ที่คุณกำลังค้นหา.
          </v-alert>
        </v-data-table>
      </base-material-card>

      <!-- Dialog: ดูไฟล์แนบ PDF ความคิดเห็น (read-only — ไม่มี action มอบหมาย/ยกเลิกในหน้านี้
           ดูรายละเอียดเหตุผลของขอบเขตนี้ในแผนงาน: ป้องกันโค้ด mutate ข้อมูลจริงซ้ำสองที่) -->
      <v-layout row justify-center>
        <v-dialog v-model="pdfDialog" max-width="90%" @click:outside="closePdfDialog">
          <v-card>
            <v-toolbar dense flat color="info darken-3" dark>
              <v-icon class="mr-2">mdi-file-pdf-box</v-icon>
              <v-toolbar-title class="subtitle-1">
                ไฟล์ผลการพิจารณา —
                <span v-if="pdfItem">{{ pdfItem.manage_name }}</span>
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <span v-if="pdfItem" class="caption mr-3 grey--text text--lighten-2">
                {{ pdfItem.MdocumentsLinkfile }}
              </span>
              <v-btn icon :href="pdfUrl" target="_blank" title="เปิดในแท็บใหม่">
                <v-icon>mdi-open-in-new</v-icon>
              </v-btn>
              <v-btn icon @click="closePdfDialog">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>

            <v-card-text class="pa-2 pb-0" v-if="pdfItem">
              <v-row dense align="center">
                <v-col cols="12" md="3">
                  <span class="caption grey--text">รหัสอ้างอิง:</span>
                  <strong class="ml-1">{{ pdfItem.manage_id_ref }}</strong>
                </v-col>
                <v-col cols="12" md="3">
                  <span class="caption grey--text">สถานศึกษาปัจจุบัน:</span>
                  <strong class="ml-1">{{ pdfItem.college_name_now }}</strong>
                </v-col>
                <v-col cols="12" md="3">
                  <span class="caption grey--text">สถานศึกษาปลายทาง:</span>
                  <strong class="ml-1">{{ pdfItem.college_name }}</strong>
                </v-col>
                <v-col cols="12" md="3">
                  <span class="caption grey--text">ความคิดเห็น:</span>
                  <v-chip
                    x-small
                    dark
                    class="ml-1"
                    :color="pdfItem.Mcommittee === 'approp' ? 'success' : 'warning'"
                  >
                    {{
                      pdfItem.Mcommittee === "approp"
                        ? "เห็นควรให้รับย้าย"
                        : "ไม่เห็นควรให้รับย้าย"
                    }}
                  </v-chip>
                </v-col>
              </v-row>
            </v-card-text>

            <v-card-text class="pa-0" style="height:78vh;">
              <iframe
                v-if="pdfDialog && pdfUrl"
                :src="pdfUrl"
                width="100%"
                height="100%"
                style="border:none; display:block;"
                type="application/pdf"
              >
                <v-alert type="warning" class="ma-4">
                  เบราว์เซอร์ของคุณไม่รองรับการแสดงผล PDF โดยตรง
                  <v-btn text color="primary" :href="pdfUrl" target="_blank"
                    >คลิกเพื่อเปิดไฟล์</v-btn
                  >
                </v-alert>
              </iframe>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-layout>
    </v-container>

    <v-container fluid>
      <v-snackbar v-model="snackbar.show" top :timeout="snackbar.timeout" :color="snackbar.color">
        <v-icon large>{{ snackbar.icon }}</v-icon>
        <v-card-text>{{ snackbar.text }}</v-card-text>
        <template v-slot:action="{ attrs }">
          <v-btn text v-bind="attrs" @click="snackbar.show = false">Close</v-btn>
        </template>
      </v-snackbar>
    </v-container>
  </div>
</template>

<script>
import transferenceManagebar from "../../components/admin/transferenceManagebar.vue";
import * as XLSX from "xlsx";

export default {
  components: { transferenceManagebar },
  data() {
    return {
      loading: false,
      ApiKey: "HRvec2021",
      snackbar: { show: false, color: "", timeout: 5000, icon: "", text: "" },
      transference_manage_locations: [],
      search: "",
      position: "",
      headers: [],
      selectedHeaders: [],
      headersMap: [
        { text: "ลำดับที่ขอย้าย", align: "center", value: "manage_location_sequence_n" },
        { text: "กรณี", align: "center", value: "manage_case_move" },
        { text: "Ref", align: "center", value: "manage_id_ref" },
        { text: "ผู้ขอย้าย", align: "left", value: "manage_name" },
        { text: "ตำแหน่งปัจจุบัน", align: "left", value: "position_name" },
        { text: "เลขที่ตำแหน่งปัจจุบัน", align: "center", value: "id_position" },
        { text: "สังกัดปัจจุบัน", align: "left", value: "college_name_now" },
        { text: "อายุงาน", align: "center", value: "manage_age_app_time" },
        { text: "ความเห็นผู้บังคับบัญชา", align: "center", value: "manage_comment_supervisor" },
        { text: "ความเห็นสถานศึกษาปลายทาง", align: "center", value: "Mcommittee", sortable: false },
        { text: "สถานะมอบหมาย", align: "center", value: "status_SELECT" },
        { text: "วิทยาลัยที่ได้รับมอบหมายจริง", align: "left", value: "college_name_suss" }
      ],
      periods: [],
      period_enable_process: "1",

      // PDF Dialog (ดูความเห็นสถานศึกษาปลายทาง) — read-only
      pdfDialog: false,
      pdfItem: null,
      pdfUrl: ""
    };
  },

  async created() {
    this.headers = Object.values(this.headersMap);
    this.selectedHeaders = this.headers;
  },

  async mounted() {
    await this.periodQuery();
    await this.transference_manage_locationQueryAll();
  },

  methods: {
    async periodQuery() {
      let result_period = await this.$http.post("period.php", {
        ApiKey: this.ApiKey,
        period_enable_process: "1",
        period_type: "manage",
        periord_admin: "check"
      });
      this.periods = result_period.data;
    },

    async transference_manage_locationQueryAll() {
      this.loading = true;
      let result = await this.$http
        .post("transference_manage_location.php", {
          ApiKey: this.ApiKey,
          mode: "list_period",
          manage_time_s: this.periods.period_times,
          manage_year_s: this.periods.period_year
        })
        .finally(() => (this.loading = false));
      this.transference_manage_locations = result.data;
    },

    async positionSearch() {
      this.loading = true;
      let result = await this.$http
        .post("transference_manage_location.php", {
          ApiKey: this.ApiKey,
          mode: "by_position",
          manage_time_s: this.periods.period_times,
          manage_year_s: this.periods.period_year,
          manage_location_position: this.position
        })
        .finally(() => (this.loading = false));
      this.transference_manage_locations = result.data;
    },

    // สรุปตำแหน่งว่างของกลุ่ม (วิทยาลัยปลายทางเดียวกันอาจมีผู้ยื่นย้ายหลายตำแหน่งปนกัน
    // เช่น ผอ. + รองผอ. พร้อมกัน — jor18_vacant_count เป็นค่าต่อ "ตำแหน่ง+ปลายทาง" ไม่ใช่ต่อวิทยาลัยเฉยๆ
    // จึงต้องแยกสรุปทีละตำแหน่งที่ปรากฏจริงในกลุ่มนั้น ไม่ใช่หยิบค่าจากแถวแรกมาแสดงตรงๆ)
    groupVacancySummary(items) {
      const map = {};
      items.forEach(item => {
        if (!item.position_name) return;
        if (!(item.position_name in map)) {
          map[item.position_name] = item.jor18_vacant_count || 0;
        }
      });
      return Object.keys(map).map(position_name => ({
        position_name,
        count: map[position_name]
      }));
    },

    exportToExcel() {
      try {
        const data = this.transference_manage_locations.map(item => {
          const row = { วิทยาลัยปลายทาง: item.college_name };
          this.showHeaders.forEach(h => {
            if (h.sortable === false) return;
            const val = item[h.value];
            row[h.text] = val !== null && val !== undefined && val !== "" ? val : "-";
          });
          return row;
        });

        const ws = XLSX.utils.json_to_sheet(data);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Manage_Location_College");

        const filename = `รายละเอียดผู้ยื่นย้ายสายบริหารตามวิทยาลัยปลายทาง_${this.periods.period_times}_${this.periods.period_year}.xlsx`;
        XLSX.writeFile(wb, filename);

        this.snackbar = {
          show: true,
          color: "success",
          icon: "mdi-check-circle",
          text: "ส่งออกไฟล์ Excel เรียบร้อย"
        };
      } catch (error) {
        console.error("Error exporting to Excel:", error);
        this.snackbar = {
          show: true,
          color: "error",
          icon: "mdi-alert-circle",
          text: "เกิดข้อผิดพลาดในการส่งออก"
        };
      }
    },

    /** เปิด Dialog ดู PDF ความคิดเห็นของสถานศึกษาปลายทาง */
    openPdfDialog(item) {
      if (!item.MdocumentsLinkfile) {
        this.snackbar = {
          show: true,
          color: "warning",
          timeout: 3000,
          icon: "mdi-alert",
          text: "ไม่พบไฟล์แนบสำหรับรายการนี้"
        };
        return;
      }
      this.pdfItem = item;
      this.pdfUrl = "/HRvecfiles/" + item.MdocumentsLinkfile;
      this.pdfDialog = true;
    },

    closePdfDialog() {
      this.pdfDialog = false;
      this.pdfItem = null;
      this.pdfUrl = "";
    }
  },

  computed: {
    showHeaders() {
      return this.headers.filter(s => this.selectedHeaders.includes(s));
    },

    // ── Dashboard สถิติ ─────────────────────────────────────────────
    statTotalApplicants() {
      return this.transference_manage_locations.length;
    },
    statTotalColleges() {
      return new Set(
        this.transference_manage_locations.map(i => i.manage_location_college_code)
      ).size;
    },
    statTotalAssigned() {
      return this.transference_manage_locations.filter(i => i.succ_college >= 1).length;
    },
    topCollegesChartSeries() {
      const counts = {};
      this.transference_manage_locations.forEach(i => {
        const name = i.college_name || "ไม่ระบุ";
        counts[name] = (counts[name] || 0) + 1;
      });
      const sorted = Object.entries(counts)
        .sort((a, b) => b[1] - a[1])
        .slice(0, 10);
      return [{ name: "จำนวนผู้ยื่นย้าย", data: sorted.map(s => s[1]) }];
    },
    topCollegesChartOptions() {
      const counts = {};
      this.transference_manage_locations.forEach(i => {
        const name = i.college_name || "ไม่ระบุ";
        counts[name] = (counts[name] || 0) + 1;
      });
      const sorted = Object.entries(counts)
        .sort((a, b) => b[1] - a[1])
        .slice(0, 10);
      return {
        chart: { type: "bar", toolbar: { show: false } },
        plotOptions: { bar: { horizontal: true, borderRadius: 4 } },
        colors: ["#B3151B"],
        xaxis: { categories: sorted.map(s => s[0]) },
        dataLabels: { enabled: true }
      };
    },
    caseMoveChartSeries() {
      const c = { normal: 0, quality: 0, special: 0 };
      this.transference_manage_locations.forEach(i => {
        if (c.hasOwnProperty(i.manage_case_move)) c[i.manage_case_move]++;
      });
      return [c.normal, c.quality, c.special];
    },
    caseMoveChartOptions() {
      return {
        chart: { type: "donut" },
        labels: ["ปกติ", "คุณภาพ", "กรณีพิเศษ"],
        colors: ["#B3151B", "#424242", "#E57373"],
        legend: { position: "bottom", fontSize: "12px" },
        dataLabels: { enabled: true, formatter: val => val.toFixed(1) + "%" }
      };
    },
    opinionChartSeries() {
      const c = { approp: 0, inapprop: 0, none: 0 };
      this.transference_manage_locations.forEach(i => {
        if (i.Mcommittee === "approp") c.approp++;
        else if (i.Mcommittee === "inapprop") c.inapprop++;
        else c.none++;
      });
      return [c.approp, c.inapprop, c.none];
    },
    opinionChartOptions() {
      return {
        chart: { type: "donut" },
        labels: ["เห็นควรให้รับย้าย", "ไม่เห็นควรให้รับย้าย", "ยังไม่ให้ความเห็น"],
        colors: ["#B3151B", "#424242", "#E57373"],
        legend: { position: "bottom", fontSize: "12px" },
        dataLabels: { enabled: true, formatter: val => val.toFixed(1) + "%" }
      };
    }
  }
};
</script>
